import api from "./Api";

class RestricaoPadraoService {
  GetRestricaoPadrao(payload) {
    return api.get("/v1/restricaoPadrao/" + payload).then((response) => {
      return response.data;
    });
  }

  PostRestricaoPadrao(payload) {
    return api.post("/v1/restricaoPadrao/", payload).then((response) => {
      return response.data;
    });
  }

  PutRestricaoPadrao(payload) {
    return api.put("/v1/restricaoPadrao/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteRestricaoPadrao(payload) {
    return api.delete("/v1/restricaoPadrao/" + payload).then((response) => {
      return response.data;
    });
  }

  GetRestricaoPadraoOData(payload) {
    return api.get("/OData/RestricaoPadrao" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new RestricaoPadraoService();
